







































































































































































































import { Component, Vue } from "vue-property-decorator";
import { apiClient } from "../../api/ApiClient";
import { baseURL } from '../../utils/request';
import moment from "moment";
import {
  createNotify,
  updateNotify,
  deleteNotify,
  notifyError,
  notifyErrorThrow
} from "@/utils/formHelper";
import TickCross from "@/components/TickCross.vue";
import Enumerable from 'linq';
import validator from 'validator';
import JsonEditor from "@/components/JsonEditor.vue";
import { get } from 'lodash';
import escapeStringRegexp from 'escape-string-regexp';
import camelcase from 'camelcase';
import sleep from 'sleep-promise';

export interface ISmsForm {
  regionWallets: { [s: string]: number };
}

@Component({
  components: {
    TickCross,
    JsonEditor,
  },
})
export default class extends Vue {

  public get Enumerable() {
    return Enumerable;
  }

  public get moment() {
    return moment;
  }

  public get get() {
    return get;
  }

  public get baseURL() {
    return baseURL;
  }

  // form
  public get rules() {
    return {
      customer: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
      password: [
        {
          required: this.formState === 'create',
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
      name: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
      wallet: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
      services: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
      regions: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
    };
  }

  public get formTitle() {
    switch (this.formState) {
      case "create":
        return this.$t('global["Create"]');
      case "edit":
        return this.$t('global["Edit"]');
      default:
        return "";
    }
  }
  public formState: string = "create";

  public form: any = null;

  public get formServices() {
    if (this.form.customer) {
      const customer = this.customers.find(p => p.id === this.form.customer);
      return customer.subscription.services;
    }

    return [];
  }

  // sms
  public formSms: ISmsForm = {} as any;
  public get formServiceTypeSmss() {
    if (this.form.customer) {
      const customer = this.customers.find(p => p.id === this.form.customer);
      if (customer.subscription.subscriptionSms) {
        return Enumerable.from(customer.subscription.subscriptionSms.subscriptionSmsCharges as any[])
          .distinct(p => p.serviceTypeSms.id)
          .select(p => p.serviceTypeSms)
          .toArray();
      }
    }

    return [];
  }

  public get formRegions() {
    if (this.form.customer && this.form.applicationSms.serviceTypeSmss) {
      const customer = this.customers.find(p => p.id === this.form.customer);
      if (customer.subscription.subscriptionSms) {
        return customer.subscription.subscriptionSms.subscriptionSmsCharges
          .filter(p => p.serviceTypeSms.id === this.form.applicationSms.serviceTypeSmss)
          .map(p => p.region);
      }
    }

    return [];
  }

  // whats app
  public get formServiceTypeWhatsApps() {
    if (this.form.customer) {
      const customer = this.customers.find(p => p.id === this.form.customer);
      if (customer.subscription.subscriptionWhatsApp) {
        return customer.subscription.subscriptionWhatsApp.serviceTypeWhatsApps;
      }
    }
    return [];
  }

  // other
  public get formWallets() {
    return this.wallets.filter(p => p.customer.id === this.form.customer);
  }

  public getService(id: number) {
    return this.services.find(p => p.id === +id);
  }

  public hasService(serviceIds: number[], name: string) {
    if (Array.isArray(serviceIds)) {
      return serviceIds.filter(p => p).some(id => this.getService(id).name === name);
    }

    return false;
  }

  public activeTab = "applicaiton";

  // api key form
  public formApiKey: any = null;
  public formApiKeyVisible = false;

  // table filter
  public serviceId: string = null;
  public username: string = null;
  public applicationName: string = null;
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  // table
  public currentPage = 1;
  public pageSize = 100;
  public total = 0;

  public formVisible = false;
  public isTableLoading = false;

  public data: any[] = [];
  public customers: any[] = [];
  public services: any[] = [];
  public get serviceTypeSmss() {
    return this.services.find(p => p.name === 'Sms').serviceTypeSmss;
  }
  public get serviceTypeWhatsApps() {
    return this.services.find(p => p.name === 'WhatsApp').serviceTypeWhatsApp;
  }
  public regions: any[] = [];
  public wallets: any[] = [];

  public formJsonEditorValue: any = null;

  public applicationCredits: any[] = [];
  public applicationCredit(id: number) {
    return this.applicationCredits.find(p => p.application.id === id);
  }
  public applicationCreditTable(id: number) {
    const credit = this.applicationCredit(id);
    if (!credit) {
      return [];
    }

    return credit.credits.map(p => ({
      ... p,
      serviceTypeSms: credit.serviceTypeSms,
    }));
  }

  public applicationWhatsappCreditTable(id: number) {
    const application = this.data.find(p => p.id === id);
    const customer = this.customers.find(p => p.id === application.customer.id);
    const wallet = application.applicationWhatsApp.applicationWhatsAppPayments[0].wallet;
    const charges = customer.subscription.subscriptionWhatsApp.subscriptionWhatsAppCharges.filter((c) => application.applicationWhatsApp.serviceTypeWhatsApps.map((a) => a.id).includes(c.serviceTypeWhatsApp.id));

    return charges.map(charge => ({
      type: charge.serviceTypeWhatsApp.name,
      credit: Math.trunc(wallet.balance/charge.outgoing),
      balance: wallet.balance,
    }));
  }

  public get filteredCustomers() {
    return this.customers.filter(p => p.account.enabled);
  }

  public mounted() {
    this.loadData();
  }

  // table events
  public async onTabClick() {
    await sleep(1);
    if (this.$refs.jsonEditor) {
      (this.$refs.jsonEditor as any).updateValue();
    }
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadApplications();
  }

  // form
  public async onClickCreate() {
    // application form
    this.form = {
      enabled: true,
      services: null,
      ipWhitelist: [],
      applicationSms: {
        regions: [],
        serviceTypeSmss: null,
        applicationSmsPayments: [],

        //
        meta: {
          sender: "",
          message: {
            aliyun: {
              template: {
                code: null,
                from: null,
                param: {}
              }
            },
            verification: {
              webhook: null
            }
          }
        },

      },
      applicationWhatsApp: {
        serviceTypeWhatsApps: null,
        applicationWhatsAppPayments: null,
        balanceNotify: {
          currency: "HKD",
          threshold: 0,
          enabled: false,
          emails: "",
        },
      },
    };

    this.formJsonEditorValue = JSON.parse(JSON.stringify(this.form.applicationSms.meta));

    // sms application
    this.formSms = {
      regionWallets: {},
    },

    // init compelted
    this.activeTab = "applicaiton";
    this.clearFormValidations();
    this.formState = "create";
    this.formVisible = true;
  }

  public onEditClick(row: any) {
    const form = JSON.parse(JSON.stringify(row));

    this.formJsonEditorValue = row.applicationSms ? JSON.parse(JSON.stringify(row.applicationSms.meta || {})) : null;

    // TODO ts 3.7
    form.applicationSms = form.applicationSms || {
      regions: [],
      serviceTypeSmss: [],
    };
    form.applicationWhatsApp = form.applicationWhatsApp || {
      serviceTypeWhatsApps: [],
      applicationWhatsAppPayments: [],
    };

    form.applicationWhatsApp.balanceNotify = form.applicationWhatsApp.balanceNotify || {
      currency: "HKD",
      threshold: 0,
      enabled: false,
      emails: "",
    };

    // form
    this.form = {
      ... form,
      ipWhitelist: [... form.ipWhitelist],
      customer: form.customer.id,
      services: form.services.length ? form.services[0].id : null,
      applicationSms: {
        ... form.applicationSms,
        serviceTypeSmss: form.applicationSms.serviceTypeSmss.length ? form.applicationSms.serviceTypeSmss[0].id : null,
        regions: form.applicationSms.regions.map(p => p.id),
      },
      applicationWhatsApp: {
        ... form.applicationWhatsApp,
        serviceTypeWhatsApps: form.applicationWhatsApp.serviceTypeWhatsApps.length ? form.applicationWhatsApp.serviceTypeWhatsApps[0].id : null,
        applicationWhatsAppPayments: form.applicationWhatsApp.applicationWhatsAppPayments.length ? form.applicationWhatsApp.applicationWhatsAppPayments[0].wallet.id : null,
      }
    };

    // sms form
    this.formSms = {
      regionWallets: Enumerable.from(form.applicationSms.applicationSmsPayments as any[])
        .toObject(p => p.region.id, p => p.wallet.id) as any,
    },

    // others
    this.activeTab = "applicaiton";
    this.formState = "edit";
    this.clearFormValidations();
    this.formVisible = true;
  }

  public onFormCancel() {
    this.formVisible = false;
  }

  public async onFormConfirm() {
    if (this.formState === "create") {
      this.onCreateConfirm();
    } else {
      this.onEditConfirm();
    }
  }

  public async onEnabledClick(row, enabled = true) {
    this.onEditClick(row);
    this.formVisible = false;
    this.form.enabled = enabled;
    await this.onFormConfirm();
  }

  // api key form
  public onApiKeyFormCancel() {
    this.formApiKeyVisible = false
  }

  // form event
  public onCustomerChange(customerId: string) {
    this.$set(this.form, 'services', null);
  }

  public onServiceChange(serviceId: string) {
    if (this.hasService([+serviceId], 'WhatsApp')) {
      this.useSubscriptionWhatsAppSetting();
    }
  }

  public async onAddIpWhitelist() {
    try {
      const { value } = await this.$prompt('Please input the ip', '', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          inputPattern: /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/g,
          inputErrorMessage: 'Invalid ip address',
        }) as any;

        if (this.form.ipWhitelist.some(p => p === value.trim())) {
          return;
        }

        this.form.ipWhitelist.push(value.trim());
    } catch (e) {
      console.error(e);
    }
  }

  public async onDeleteIpWhitelist(index) {
    this.form.ipWhitelist.splice(index, 1);
  }

  // table event
  public async onClickShowApiKey(row: any) {
    try {
      // await this.$prompt('Please input customer name', '', {
      //   confirmButtonText: 'OK',
      //   cancelButtonText: 'Cancel',
      //   inputPattern: new RegExp(`^${escapeStringRegexp(row.customer.account.username)}$`, 'i'),
      //   inputErrorMessage: 'customer name incorrect',
      // });
      this.formApiKey = row;
      this.formApiKeyVisible = true;
    } catch(e) {
      console.log(e);
    }
  }

  public async onPaginationChange() {
    await this.loadData();
    this.$scrollTo("#data-table");
  }

  public async onRenewApiKeyClick(row) {
    try {
      await this.$confirm('Are you sure reset api key?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
    } catch(e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      await apiClient.applicationRenewApiKey(row.id);
      updateNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadData();
  }

  // init / loads
  private async loadData() {
    await Promise.all([
      this.loadApplications(),
      this.loadCustomers(),
      this.loadRegions(),
      this.loadServices(),
      this.loadWallets(),
    ]);
  }

  private async loadApplications() {
    this.isTableLoading = true;
    const { data } = await apiClient.applications({
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      serviceId: this.serviceId || undefined,
      username: this.username,
      applicationName: this.applicationName,
    });
    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;

    await this.loadApplicationCredits();
  }

  private async loadCustomers() {
    const { data } = await apiClient.customers({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.customers = data.data;
  }

  private async loadRegions() {
    const { data } = await apiClient.regions();
    this.regions = data;
  }

  private async loadServices() {
    const { data } = await apiClient.services();
    this.services = data;
  }

  private async loadWallets() {
    const { data } = await apiClient.wallets({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.wallets = data.data;
  }

  private async loadApplicationCredits() {
    const { data } = await apiClient.applicationsCreditsSearch({
      applications: this.data.map(p => ({ id: p.id })),
    });
    this.applicationCredits = data;
  }

  // events
  private async onCreateConfirm() {
    try {
      this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      const { data } = await apiClient.postApplications(this.getForm());
      this.formVisible = false;
      createNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadData();
  }

  private async onEditConfirm() {
    try {
      this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      await apiClient.putApplications(this.form.id, this.getForm());
      this.formVisible = false;
      updateNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadData();
  }

  private getForm() {
    return {
      ... this.form,

      customer: {
        id: this.form.customer,
      },

      services: [this.services.find(service => service.id === this.form.services)],

      // sms
      applicationSms: {
        regions: this.form.applicationSms.regions.map(regionId => this.regions.find(p => p.id === regionId)),
        serviceTypeSmss: [this.serviceTypeSmss.find(p => p.id === this.form.applicationSms.serviceTypeSmss)],
        applicationSmsPayments: Object.entries(this.formSms.regionWallets)
        .map(([regionId, walletId]) => ({
          region: {
            id: +regionId,
          },
          wallet: {
            id: walletId,
          },
        })),
        meta: this.$refs.jsonEditor ? JSON.parse((this.$refs.jsonEditor as any).getValue()) : {},
      },

      // whats app
      applicationWhatsApp: {
        ... this.form.applicationWhatsApp,
        serviceTypeWhatsApps: [this.formServiceTypeWhatsApps.find(p => p.id === this.form.applicationWhatsApp.serviceTypeWhatsApps)],
        applicationWhatsAppPayments: [{
          wallet: this.formWallets.find(p => p.id === +this.form.applicationWhatsApp.applicationWhatsAppPayments),
        }],
      },


    };
  }

  private clearFormValidations() {
    if (this.$refs.form) {
      (this.$refs.form as any).clearValidate();
    }
  }

  private validateForm() {
    if (!this.form.name) {
      notifyErrorThrow.bind(this)("missing name");
    }

    if (!this.form.services) {
      notifyErrorThrow.bind(this)("please choose atleast 1 service");
    }

    // others
    if (this.hasService([this.form.services], 'Sms')) {
      this.validateSmsForm();
    }

    if (this.hasService([this.form.services], 'WhatsApp')) {
      this.validateWhatsAppForm();
    }
  }

  private validateSmsForm() {
    if (!this.form.applicationSms.serviceTypeSmss) {
      notifyErrorThrow.bind(this)("please select sms type");
    }

    if (!this.form.applicationSms.regions.length) {
      notifyErrorThrow.bind(this)("please select atleast 1 region");
    }

    for (const region of this.form.applicationSms.regions) {
      if (!this.formSms.regionWallets[region]) {
        notifyErrorThrow.bind(this)("please select sms payment");
      }
    }
  }

  private validateWhatsAppForm() {
    if (!this.form.applicationWhatsApp.serviceTypeWhatsApps) {
      notifyErrorThrow.bind(this)("please select whatsApp type");
    }
    if (!this.form.applicationWhatsApp.applicationWhatsAppPayments) {
      notifyErrorThrow.bind(this)("please select whatsApp payment");
    }
    if (!this.form.applicationWhatsApp.whatsAppNumber) {
      notifyErrorThrow.bind(this)("please select whatsApp number");
    }
    if (!this.form.applicationWhatsApp.authToken) {
      notifyErrorThrow.bind(this)("please select whatsApp auth token");
    }
    if (this.form.applicationWhatsApp.messageComesInUrl && !validator.isURL(this.form.applicationWhatsApp.messageComesInUrl)) {
      notifyErrorThrow.bind(this)("Incoming Message url is invalid");
    }
    if (this.form.applicationWhatsApp.statusCallbackUrl && !validator.isURL(this.form.applicationWhatsApp.statusCallbackUrl)) {
      notifyErrorThrow.bind(this)("Status Report url is invalid");
    }
  }

  // whats app
  private useSubscriptionWhatsAppSetting() {
    const customer = this.customers.find(p => p.id === this.form.customer);
    // TODO ts 3.7
    if (customer.subscription.subscriptionWhatsApp) {
      this.$set(this.form, 'applicationWhatsApp', {
        ... this.form.applicationWhatsApp || {},
        whatsAppNumber: customer.subscription.subscriptionWhatsApp.whatsAppNumber,
        authToken: customer.subscription.subscriptionWhatsApp.authToken,
      });
    }
  }
}
